
import React from 'react'

const Footer = () => {
  return <footer>
    <div>
        <h1>Techystar</h1>
        <p>@all right reserved</p>
    </div>
    <div>
        <h5>Follow us</h5>
        <div>
            <a href="https://www.youtube.com/channel/UClYw7YGvAfCnBJtizFThEfg" target={"blank"}>Youtube</a>
            <a href="https://www.instagram.com/prabhu_nath19/" target={"blank"}>Instagram</a>
            <a href="https://github.com/prabhunath-code" target={"blank"}>Github</a>
        </div>
    </div>
  </footer>
   
  
}

export default Footer